function HeroJet(){
    return(
        <div class="jet-container">
            <div class="jet"></div>
        </div>
    )
}

export default HeroJet